import { createSlice } from "@reduxjs/toolkit";

export const stopDiscoverySiteSlice = createSlice({
  name: "onPremStopDiscoverySiteDevices",
  initialState: {
    data: {},
  },
});

export default stopDiscoverySiteSlice.reducer;